export default {
    install(app, options) {
        app.config.globalProperties.siteRoute = (routename, params   = {}) => {
            return window.siteDomain + route(routename, params, false);
        }

        window.siteRoute = app.config.globalProperties.siteRoute
    }
}
